<script>
  import options from './OverlayPrompt.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
    <div class="be-overlay__title">
      {{ titleText }}
        <button @click="closeTheModal" autofocus class="be-overlay__close-button" aria-label="close">
          <svg role="presentation" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_4322_10989)"><path d="M33 11L11 33" stroke="#1E2B24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 11L33 33" stroke="#1E2B24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_4322_10989"><rect width="44" height="44" fill="white"/></clipPath></defs></svg>
        </button>
    </div>
      
    <template v-if="useFixedTemplate">
      <div class="be-overlay__content">
        <div class="be-overlay-prompt__content">This is a prompt</div>
        <div class="be-overlay-prompt__content-buttons">
          <button class="be-btn">button</button>
          <button class="be-btn be-btn--outline">button</button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="be-overlay__content" v-html="htmlString">
      </div>
    </template>

</template>